/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { ICarousel } from "../../interfaces/ICarousel";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import { QualyProms } from "../../utils/qualy-proms";
import { useState } from "react";

export default function MyCarousel({
  slides,
  favorites,
  setFavorite,
  user,
}: {
  slides: ICarousel[];
  favorites: any;
  setFavorite: any;
  user: any
}) { 
  const [isPlaying, setIsPlaying] = useState(false);
  return (
    <div>
      <div className="shadow-sm border-0 rounded-2xl px-2 py-3 w-full">
        <div id="container" className="overflow-hidden relative rounded-xl">
          <div
            className={
              "relative flex justify-center bg-white cursor-pointer hover:scale-110 transition-transform duration-300"
            }
            style={{
              maxHeight: "300px",
            }}
            onMouseEnter={() => setIsPlaying(true)}
            onMouseLeave={() => setIsPlaying(false)}
          >
            <label
              className={`cursor-pointer absolute ${user == undefined ? 'hidden' : ''}`}
              style={{ top: "20px", right: "20px", zIndex: 2 }}
            >
              {favorites?.data.filter((f: any) => f.property_id == slides[0].id)
                .length > 0 ? (
                <img
                  src="./src/assets/img/favorito.png"
                  alt=""
                  style={{ width: "20px" }}
                />
              ) : (
                <img
                  src="./src/assets/img/favorito3.png"
                  alt=""
                  style={{ width: "20px" }}
                />
              )}

              <button
                className="hidden"
                onClick={() => setFavorite(slides[0], favorites)}
              ></button>
            </label>
            <Carousel
              autoPlay={isPlaying}
              //centerMode={true}
              dynamicHeight={true}
              infiniteLoop={true}
              showArrows={false}
              showStatus={false}
              showIndicators={true}
              showThumbs={false}
            >
              {slides.map((img: any, index: any) => {
                return (
                  <img
                    src={img.url}
                    alt=""
                    key={index}
                    style={{
                      width: "100%",
                      minHeight: "250px",
                      maxHeight: "250px",
                      objectFit: "cover",
                    }}
                    className="bg-gray-30 "
                  />
                );
              })}
            </Carousel>
          </div>
          <div className="absolute bottom-3 right-0 left-0"></div>
        </div>
        <div className="text-start py-3">
          <span className="flex justify-between items-center">
            <Link
              className="font-bold"
              style={{ fontSize: "90%" }}
              to={slides[0].link}
            >
              {slides[0].title}
            </Link>
            <span
              className="flex items-center font-bold"
              style={{ fontSize: "12px" }}
            >
              <i className="bi bi-star-fill me-2"></i>
              {QualyProms(slides[0].ratings)} 
            </span>
          </span>
          <p  style={{ fontSize: "90%", marginBottom: "0px", lineHeight: "1" }}>
            {slides[0].distance}
          </p>
          <p className="texto-description" style={{ fontSize: "90%", marginBottom: "0px" }}>
            {slides[0].available}
          </p>
          <p className="font-bold " style={{ fontSize: "100%" }}>
            {`${slides[0].fee} `}
            <span className="font-normal">noche</span>
          </p>
        </div>
      </div>
    </div>
  );
}
